import { TrainingRecordEntity } from 'src/store/training-record/training-record.model';
import { AircraftMakeModelViewModel } from './aircraft-make-model-view-model';
import { PilotViewModel, PrdProcessingState } from './pilot-view-model';
import { TrainingEventViewModel } from './training-event-view-model';
import { TrainingProgramViewModel } from './training-program-view-model';

export enum PrdDutyPositionType {
  PIC = 'PIC',
  SIC = 'SIC',
}

export enum PrdResultType {
  SAT = 'SAT',
  UNSAT = 'UNSAT',
}
export interface PrdAircraftMakeModel {
  id: string;
  code: string;
  description: string;
}
export interface PrdTrainingProgram {
  id: string;
  code: string;
  description: string;
}
export interface PrdTrainingEvent {
  id: string;
  code: string;
  description: string;
}
export interface PrdTrainingProgramTrainingEventMap {
  id: string;
  trainingProgramId: string;
  trainingEventId: string;
}

export class TrainingRecordViewModel implements TrainingRecordEntity {
  public id: string;
  public pilotId: string;
  public startDate: Date;
  public endDate: Date;
  public aircraftMakeModelId: string;
  public dutyPosition: PrdDutyPositionType;
  public trainingProgramId: string;
  public trainingEventId: string;
  public result: PrdResultType;
  public otherEventDescription: string;
  public evaluatorComments: string;
  public unsatisfactoryComments: string;
  public suppressed: boolean;
  public processingState: PrdProcessingState;
  public processingError: string;
  public lastProcessedDate: Date;
  public prdSourceSystemId: string;
  public pilot: PilotViewModel;
  public aircraftMakeModel: AircraftMakeModelViewModel;
  public trainingEvent: TrainingEventViewModel;
  public trainingProgram: TrainingProgramViewModel;

  constructor(trainingRecord: TrainingRecordEntity) {
    Object.assign(this, trainingRecord);
  }
}

export class TrainingRecordWithAdditionalPropsViewModel extends TrainingRecordViewModel {
  public pilot: PilotViewModel;
  public aircraftMakeModel: AircraftMakeModelViewModel;
  public trainingEvent: TrainingEventViewModel;
  public trainingProgram: TrainingProgramViewModel;

  constructor(trainingRecord: TrainingRecordEntity) {
    super(trainingRecord);
    // Object.assign(this, trainingRecord);
  }
}
